import { useAppUser } from '../admin/AppUserContext';
import { Link } from 'react-router-dom';
import { UserButton } from '@clerk/clerk-react';
import { Globe } from 'lucide-react';
import { CLOUDFLARE_STATIC_ASSETS } from '../config/cloudflareAssets';
import NotificationBell from '../components/NotificationBell';

export default function AdviserWorkspaceHeader({
  title,
  subtitle,
}: {
  title: string;
  subtitle?: string;
}) {
  const { isSupportSession } = useAppUser();
  return (
    <header className="adviser-workspace-header">
      <Link
        className="adviser-workspace-brand"
        to="/dashboard"
        aria-label="StratPlan company dashboard"
      >
        <img src={CLOUDFLARE_STATIC_ASSETS.LOGO_LIGHT} alt="StratPlan" />
      </Link>
      <div className="adviser-workspace-heading">
        <h1>{title}</h1>
        {subtitle && <p>{subtitle}</p>}
      </div>
      <div className="adviser-workspace-account">
        <Link className="adviser-text-link" to="/advisers" aria-label="Public adviser directory">
          <Globe size={17} />
          <span>Public directory</span>
        </Link>
        {!isSupportSession && (
          <>
            <NotificationBell />
            <UserButton />
          </>
        )}
      </div>
    </header>
  );
}
